<template>
	<b-form
		ref="form"
		@submit.prevent="add"
	>
		<b-form-group>

			<b-form-checkbox
				v-for="clock in customerClocks"
				:key="clock.Id"
				:value="clock"
				v-model="clocks"
				:disabled="clock.Disabled"
				size="lg"
			>{{ clock.Name }} - {{ clock.Address.Town }} {{ clock.Disabled }}</b-form-checkbox>
		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Add To Contract</b-button>

	</b-form>
</template>


<script>
import CustomerService from "@/api-services/customer.service";

export default {
	name: "AddClocksToContract",

	// things we want to use
	components: {},

	// things we have inherited from our parent
	props: ["contract"],

	created() {
		this.fetchCustomerClocks();
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			clocks: [],
			customerClocks: []
		};
	},

	// things we do to data
	methods: {
		fetchCustomerClocks() {
			let customerId = this.contract.Customer.Id;

			CustomerService.get(customerId).then(response => {
				let customer = response.data;

				this.customerClocks = customer.Clocks;

				this.customerClocks.map(clock => {
					if (clock.ServiceContractId != null) {
						clock.Disabled = true;
					}
					return clock;
				});
			});
		},

		add() {
			// push this sucka back to the parent
			this.$emit("addClocks", this.clocks);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/add-clocks-to-contract.vue